import { DrawingItemTypeEnum } from "../enums/DrawingItemTypeEnum";

export class PhotoObjectDto {
  metadata: string;

  constructor(metadata: string) {
    this.metadata = metadata;
  }
}
